<template>
  <div class="main-header-left">
    <div class="breadcrumbs">
      <CarReturnLink v-if="car.company" :companyId="car.company.id" />

      <RouterLink v-show="!mobile" :class="classPreloader" :to="companyUrl">
        {{ companyName }}
      </RouterLink>

      <!--      <RouterLink v-if="getFlokkar(car.flokkar_id)" :to="cat_url"
                   class="breadcrumbs-item"
                   :class="{ 'b-empty shine-short': !loaded }"
                   @click.native="resetScrollTop()">
        {{ getFlokkar(car.flokkar_id).name}}
      </RouterLink>-->

      <template v-if="visibleBreadCrumbs">
        <RouterLink
            v-for="(type, index) in car.newCarsCatsVia"
            :key="index"
            :to="type_url(type.id)"
            :class="[classPreloader, {'comma': index != car.newCarsCatsVia.length - 1}]"
            @click.native="resetScrollTop()">
          {{ type.name }}
        </RouterLink>
      </template>

      <RouterLink
          :to="brand_url"
          :class="classPreloader"
          class="mobile-breadcrumbs-item"
          @click.native="resetScrollTop()">
        {{ car.brand }}
      </RouterLink>

      <RouterLink
          v-if="car.model_class"
          :to="brand_model_url"
          :class="classPreloader"
          class="mobile-breadcrumbs-item"
          @click.native="resetScrollTop()">

        {{ car.model_class }}
      </RouterLink>

      <RouterLink
          v-if="car.model_year && !mobile"
          :to="yearUrl"
          :class="classPreloader">

        {{ car.model_year }}
      </RouterLink>
    </div>
<!--    <span class="main-header-serial-number">
      {{ carNumberName }}
      <b class="main-header-serial-number&#45;&#45;b" :class="{ 'b-empty shine-short': !loaded }">
        {{ carNumber }}
      </b>
    </span>-->
  </div>
</template>

<script>
import CarReturnLink from "@/components/Dealers/CarReturnLink.vue";
import urls from "@/mixins/newCars/urls";
import {mapState, mapGetters} from "vuex";

export default {
  props: {
    car: {
      type: Object,
      require: true
    },
    loaded: Boolean
  },
  mixins: [urls],
  components: {
    CarReturnLink,
  },
  methods: {
    resetScrollTop() {
      this.$store.state.scrollPositionPageDealers = 0;
    },
    type_url(id) {
      const pageUrl = "/" + this.$route.path.split("/")[1];
      return (
          pageUrl +
          this.setUrlParams({
            cat: [id],
          })
      );
    },
  },
  computed: {
    ...mapState({
      screenWidth: state => state.screen.width
    }),

    ...mapGetters("dealers", ["getFlokkar"]),

    visibleBreadCrumbs() {
      return this.screenWidth > 1560
    },
    mobile() {
      return this.screenWidth <= 560
    },
    carNumberName() {
      return this.routeCarStock ? (this.car.registration_number ? "Fastanúmer:" : "") : "Raðnúmer:";
    },
    carNumber() {
      return this.routeCarStock ? this.car.registration_number ? this.car.registration_number : "" : this.car.id
    },
    routeCarStock() {
      return this.$route.name == "CarInStock";
    },

    pageUrl() {
      return "/" + this.$route.path.split("/")[1];
    },

    cat_url() {
      return this.pageUrl + this.setUrlParams({cat: [this.car.flokkar_id]});
    },

    brand_url() {
      return this.pageUrl + this.setUrlParams({brands: [this.car.brand_id]});
    },

    companyName() {
      return this.car.company && this.car.company.name;
    },

    companyUrl() {
      return this.car.company
          ? this.pageUrl + this.setUrlParams({company: [this.car.company.id]})
          : ""
    },

    yearUrl() {
      return this.pageUrl + this.setUrlParams({year: [this.car.model_year]});
    },

    brand_model_url() {
      return (
          this.pageUrl +
          this.setUrlParams({
            models_id: [this.car.model_id],
            brands: [this.car.brand_id],
          })
      );
    },

    classPreloader() {
      return 'breadcrumbs-item ' + (!this.loaded
          ? 'b-empty shine-short'
          : '')
    }
  },
};
</script>